import cacheLs from "../cacheLs"

export default {
  addPlanAmount (state, data) {
    state.selectedPlanAmount = { ...data }
    cacheLs.set_plan_amount(data)
  }
}
